import { Component } from 'react';
import Footer from "../Footer";

class FooterEN extends Component {
    render() {
      return (
          
        <Footer 
            contact={{
                title:"Contact us", 
                email: { key:"Email", value:"info@coeladvocaten.be" },
                lines: [
                    { text:"" },      
                    { text:"Tel: +32 15 41 76 36"},
                    { text:"Fax: +32 15 43 21 55"},
                    { text:"" },                                                    
                    { text:"Our offices are open from 8:30 AM to 5:30 PM." },
                    { text:"Consultation by appointment only" },
                    { text:"" },
                    { text:"BV Frank Coel Lawyer"},
                    { text:"Schuttersvest 78, 2800 Mechelen"},
                    { text:"CBE: BE 0861.086.519" },
                ]
            }}

            info={{
                title:"Legal information", 
                lines: [
                    { text:"The lawyers are registered with the Bar of the Province of Antwerp." },
                    { text:"" },
                    { text:"The lawyers are insured for professional liability with Amlin Europe NV, through Vanbreda Risk & Benefits with policy number LXX034899." },
                    { text:"" },
                    { text:"This insurance provides a guarantee of 1,250,000.00 euros per claim."},
                    { text:"" },
                    { text:"The client is responsible for providing all information regarding their file, with the confidentiality of the information being covered by the lawyer's professional secrecy."},
                ]
            }}

            links={{
                title:"Useful links", 
                items: [
                    { url:"/en", name:"Home" },
                    { url:"/en/frank-coel", name:"Frank Coel" },
                    { url:"/en/anna-mamchenkova", name:"Anna Mamchenkova" },
                    { url:"/en/companies-in-difficulty", name:"Companies in difficulty" },
                    { url:"/en/advice-defense-disputes", name:"Advice, defense and disputes" },
                    { url:"/en/publications", name:"Publications" },
                    { url:"/en/press", name:"Press" },
                    { url:"/en/general-terms-and-conditions", name:"Rates & Fees" },
                    { url:"/en/contact", name:"Contact" },
                ]
            }}

            articles={{
                title:"Press", 
                items: [
                    { url:"/en/press#1", name:"Somers' party colleague leads protest against Schuttersvest parking" },
                    { url:"/en/press#2", name:"Soil pollution can stop Schuttersvest parking construction" },
                    { url:"/en/press#3", name:"Arson committed to avenge sister Olga" },
                    { url:"/en/press#4", name:"Undocumented child (10) without family in police cell" },
                    { url:"/en/press#5", name:"Kucam case is based on rumors" },
                    { url:"/en/press#6", name:"A certain Frank, from parliament, organizes visas for payment" },
                ]
            }}

            condition={{ url:"/en/general-terms-and-conditions", name:"General terms and conditions" }}
            privacy={{ url:"/en/privacy-policy", name:"Privacy policy" }}
            copyright="COELADVOCATEN - 78, Schuttersvest, 2800 Mechelen, Belgium"
            designer={{ url:"https://www.bewive.be", name:"Design by Bewive", alt:"Go to the design website" }}
            cookies={{ url:"/en/privacy-policy", name:"privacy policy", text:"By continuing to browse this site, you accept the use of cookies", button:"I accept" }}
        />
          
      );
    }
  }
  
  export default FooterEN
